export default __webpack_public_path__ + "static/media/itaucard-insurance.36122653.svg";